<template>
    <layout-login>
        <v-row align="center" justify="center" no-gutters>
            <v-col cols="12" sm="8" md="3">
                <v-card :loading="isBusy">
                    <v-form @submit.prevent="onSubmit">
                        <v-card-text>
                            <v-text-field :label="$t('login.username')"
                                          v-model="$v.form.username.$model"
                                          :error-messages="usernameErrors"
                                          name="login"
                                          prepend-icon="person"
                                          type="text"
                                          required
                                          @input="$v.form.username.$touch()"
                                          @blur="$v.form.username.$touch()"
                            />
                            <v-text-field :label="$t('login.password')"
                                          v-model="$v.form.password.$model"
                                          :error-messages="passwordErrors"
                                          name="password"
                                          prepend-icon="lock"
                                          type="password"
                                          required
                                          @input="$v.form.password.$touch()"
                                          @blur="$v.form.password.$touch()"
                            />
                        </v-card-text>
                        <v-card-actions>
                            <v-btn type="submit"
                                   color="primary"
                                   block
                                   :disabled="isBusy"
                            >
                                {{ $t('login.login_button') }}
                            </v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-col>
        </v-row>
    </layout-login>
</template>

<script>
    import LayoutLogin from "@/layouts/LayoutLogin";
    import {API} from "@/api/api";
    import SnackbarMixin from "@/mixins/SnackbarMixin";
    import {validationMixin} from "vuelidate";
    import {required} from "vuelidate/lib/validators";

    export default {
        name: 'Login',
        mixins: [SnackbarMixin, validationMixin],
        components: {LayoutLogin},
        data: () => ({
            // loading
            isBusySubmit: false,
            // form data
            form: {
                username: null,
                password: null
            }
        }),
        validations: {
            form: {
                username: {required},
                password: {required},
            }
        },
        computed: {
            isBusy() {
                return this.isBusySubmit;
            },
            usernameErrors() {
                const errors = [];
                if (!this.$v.form.username.$dirty) return errors;
                !this.$v.form.username.required && errors.push(this.$t('validation.username.required'));
                return errors;
            },
            passwordErrors() {
                const errors = [];
                if (!this.$v.form.password.$dirty) return errors;
                !this.$v.form.password.required && errors.push(this.$t('validation.password.required'));
                return errors;
            },
        },
        methods: {
            onSubmit() {
                this.$v.form.$touch();
                if (this.$v.form.$anyError) {
                    return;
                }

                let data = {
                    username: this.form.username,
                    password: this.form.password
                };

                this.isBusySubmit = true;
                API.post('/login', data)
                    .then(response => {
                        // reset previous local storage
                        this.$store.commit('bulkOrder/reset');
                        this.$store.commit('editBulkOrder/reset');
                        this.$store.commit('editOrder/reset');
                        this.$store.commit('filter/reset');
                        this.$store.commit('identity/removeAuthInfo');
                        this.$store.commit('shoppingCart/reset');
                        this.$store.commit('snackbar/resetSnackbar');
                        this.$store.commit('warehouse/reset');
                        // set auth info
                        this.$store.commit('identity/setAuthInfo', response.data);
                        // change locale based on logged-in user
                        this.$i18n.locale = response.data.locale;
                        this.snackbarSuccess(this.$t("snackbar.login_success"));
                        if (response.data.roles.includes('ROLE_ADMIN')) {
                            this.$router.push({name: 'admin'});
                        } else {
                            this.$router.push({name: 'home'});
                        }
                    })
                    .catch(error => {
                        this.snackbarError(error);
                    })
                    .finally(() => {
                        this.isBusySubmit = false;
                    });
            }
        }
    }
</script>
